<template>
    <div id="body">
        <!-- Header Component -->
        <top-navbar/>
        <article class="master-wrapper">
            <!-- Hero Image Component -->
            <hero-image/>
            <section class="master-section container">
                <div class="row no-gutters">
                    <!-- Main Body of Content -->
                    <main-content/>
                    <!-- Side Bar Component -->
                    <!-- <side-bar/> -->
                </div>
            </section>
            <!-- Sponsor Component -->
            <sponsors/>
            <!-- Associated Sites Component -->
            <associated-sites/>
        </article>
        <!-- Footer Component -->
        <content-footer/>
    </div>
	
</template>
<script>
    import TopNavbar from "./TopNavbar.vue";
    import HeroImage from "./HeroImage";
    import MainContent from "./MainContent.vue";
    // import SideBar from "./SideBar";
    import Sponsors from "./Sponsors";
    import AssociatedSites from "./AssociatedSites";
    import ContentFooter from "./ContentFooter.vue";
    import EventBus from '../eventBus'

    export default {
        components: {
            TopNavbar,
            HeroImage,
            MainContent,
            // SideBar,
            Sponsors,
            AssociatedSites,
            ContentFooter,
        },
        data(){
            return {
                year: new Date().getFullYear()
            }
        },
        mounted(){
            EventBus.$emit("get-year", this.year)
        }
    };
</script>